import React from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';
import {
  FaExclamationTriangle,
  FaCheckCircle,
  FaBell,
} from 'react-icons/fa';

const AlertSummaryCards = ({ summary }) => {
  const hasCritical = (summary?.criticas ?? 0) > 0;

  const cards = [
    {
      key: 'activas',
      title: 'Alertas Activas',
      count: summary?.requieren_atencion ?? 0,
      subtitle: 'Requieren atención',
      color: '#dc2626',
      bgColor: '#fff1f2',
      icon: <FaExclamationTriangle />,
    },
    {
      key: 'criticas',
      title: 'Alertas Críticas',
      count: summary?.criticas ?? 0,
      subtitle: 'Atención inmediata',
      color: '#f59e0b',
      bgColor: '#fff8eb',
      icon: <FaBell />,
    },
    {
      key: 'advertencia',
      title: 'Alertas de Advertencia',
      count: summary?.advertencia ?? 0,
      subtitle: 'Revisar pronto',
      color: '#f59e0b',
      bgColor: '#fff8eb',
      icon: <FaExclamationTriangle />,
    },
    {
      key: 'situacion',
      title: 'Situación General',
      count: hasCritical ? 'Atención' : 'Estable',
      subtitle: hasCritical
        ? 'Requiere atención'
        : 'Sin cambios críticos',
      color: hasCritical ? '#dc2626' : '#16a34a',
      bgColor: hasCritical ? '#fff1f2' : '#edf9f1',
      icon: hasCritical ? <FaExclamationTriangle /> : <FaCheckCircle />,
      isSituation: true,
    },
  ];

  return (
    <Row className="mb-4 g-3">
      {cards.map((card) => (
        <Col lg="3" md="6" xs="12" key={card.key}>
          <Card
            className="h-100"
            style={{
              backgroundColor: '#ffffff',
              border: '1px solid #e9edf2',
              borderRadius: '8px',
              boxShadow: '0 1px 4px rgba(0, 0, 0, 0.03)',
              minHeight: '96px',
            }}
          >
            <CardBody
              style={{
                padding: '16px 18px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '14px',
                }}
              >
                {/* ICONO */}
                <div
                  style={{
                    width: '58px',
                    height: '58px',
                    minWidth: '58px',
                    borderRadius: '50%',
                    backgroundColor: card.bgColor,
                    color: card.color,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '23px',
                  }}
                >
                  {card.icon}
                </div>

                {/* INFORMACIÓN */}
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                  }}
                >
                  {/* TÍTULO */}
                  <div
                    style={{
                      color: '#273142',
                      fontSize: '12px',
                      fontWeight: '600',
                      lineHeight: '1.2',
                      marginBottom: '4px',
                    }}
                  >
                    {card.title}
                  </div>

                  {/* NÚMERO / ESTADO */}
                  <div
                    style={{
                      color: card.color,
                      fontSize: card.isSituation ? '18px' : '20px',
                      fontWeight: '700',
                      lineHeight: '1.1',
                      marginBottom: '4px',
                    }}
                  >
                    {card.count}
                  </div>

                  {/* SUBTÍTULO */}
                  <div
                    style={{
                      color: '#697586',
                      fontSize: '10px',
                      lineHeight: '1.2',
                    }}
                  >
                    {card.subtitle}
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );
};

export default AlertSummaryCards;